<template>
  <div id="app">
    <div class="app-main">
      <Nav
        v-show="!hideNav"
        :isNavCollapsed="isNavCollapsed"
        @collapse="isNavCollapsed = true"
      ></Nav>
      <img
        class="thumb"
        src="@/assets/logo.png"
        alt="logo"
        @click="showNav"
        v-show="isNavCollapsed && !hideNav"
      />

      <div class="app-container">
        <!-- <keep-alive> -->
        <!-- <router-view v-if="$route.meta.keepAlive" /> -->
        <router-view />
        <!-- </keep-alive> -->
        <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav/Nav.vue";
import { checkVersion, unCheckVersion } from "version-rocket";

export default {
  components: {
    Nav,
  },
  data() {
    return {
      hideNav: true,
      isNavCollapsed: false,
    };
  },
  watch: {
    $route: function () {
      if (this.$route.path == "/login" || this.$route.path == "/auth-loading") {
        this.hideNav = true;
      } else {
        this.hideNav = false;
      }
    },
  },
  mounted() {
    // 若 URL 中携带用于穿透强缓存的 v_t 时间戳参数，在页面加载完成后静默清理地址栏中的 v_t，保持 URL 美观
    const url = new URL(window.location.href);
    if (url.searchParams.has("v_t")) {
      url.searchParams.delete("v_t");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }

    if (process.env.NODE_ENV === "production" && process.env.VUE_APP_VERSION) {
      checkVersion({
        localPackageVersion: process.env.VUE_APP_VERSION,
        originVersionFileUrl: `${location.origin}/version.json`,
        pollingTime: 300000,
        clearIntervalOnDialog: true,
        onVersionUpdate: (event) => {
          // 安全拦截：若获取到的线上版本号为 undefined、null 或空字符串，说明是接口挂了、被代理重定向或线上静态版文件尚未发布，拦截弹窗，防止死循环
          const newVersion = event ? event.refreshPageVersion : null;
          if (
            !newVersion ||
            newVersion === "undefined" ||
            newVersion === "null"
          ) {
            return;
          }
          // 触发提示后立即停止 Web Worker 监听，防止重复提示
          unCheckVersion({ closeWorker: true });

          const message = "系统已发布新版本，请刷新页面以获取最新功能。";
          const title = "更新提示";

          const handleReload = () => {
            // 通过修改 URL 加随机时间戳，强制浏览器从服务端拉取最新的 index.html 和代码包，彻底解决浏览器强缓存导致的弹窗死循环问题
            const url = new URL(window.location.href);
            url.searchParams.set("v_t", Date.now().toString());
            window.location.replace(url.toString());
          };
          if (this.$confirm) {
            this.$confirm(message, title, {
              confirmButtonText: "立即刷新",
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
              type: "warning",
            })
              .then(() => {
                handleReload();
              })
              .catch(() => {
                handleReload();
              });
          } else {
            let confirmed = false;
            while (!confirmed) {
              confirmed = window.confirm(
                `${title}\n\n${message}\n\n点击确定以刷新页面。`,
              );
            }
            handleReload();
          }
        },
      });
    }
  },
  beforeDestroy() {
    if (process.env.NODE_ENV === "production") {
      unCheckVersion({ closeDialog: true, closeWorker: true });
    }
  },
  methods: {
    showNav() {
      this.isNavCollapsed = false;
      const header = document.querySelector(".page-header");
      if (header) {
        header.style.height = "";
      }
      const main = document.querySelector(".page-main");
      if (main) {
        main.style.paddingLeft = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.app-main {
  height: 100vh;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;

  .thumb {
    position: fixed;
    top: 0px;
    right: 0px;
    z-index: 999;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
  }
}
</style>
